import { db } from "@/lib/firebase";
import { doc, getDoc } from 'firebase/firestore';

const europeanCountries = ['Albania', 'Andorra', 'Armenia', 'Austria', 'Azerbaijan', 'Belarus', 'Belgium', 'Bosnia and Herzegovina', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic', 'Denmark', 'Estonia', 'Finland', 'France', 'Georgia', 'Germany', 'Greece', 'Iceland', 'Ireland', 'Italy', 'Kazakhstan', 'Kosovo', 'Latvia', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macedonia', 'Malta', 'Moldova', 'Monaco', 'Montenegro', 'Netherlands', 'Norway', 'Poland', 'Portugal', 'Romania', 'Russia', 'San Marino', 'Serbia', 'Slovakia', 'Slovenia', 'Spain', 'Sweden', 'Switzerland', 'Ukraine', 'United Kingdom', 'Vatican City'];
const africaCountries = ['Algeria', 'Angola', 'Benin', 'Botswana', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cameroon', 'Central African Republic', 'Chad', 'Comoros', 'Democratic Republic of the Congo', 'Republic of the Congo', "Cote d'Ivoire", 'Djibouti', 'Equatorial Guinea', 'Eritrea', 'Ethiopia', 'Gabon', 'Gambia', 'Ghana', 'Guinea', 'Guinea Bissau', 'Kenya', 'Lesotho', 'Liberia', 'Libya', 'Madagascar', 'Malawi', 'Mali', 'Mauritania', 'Mauritius', 'Morocco', 'Mozambique', 'Namibia', 'Niger', 'Nigeria', 'Rwanda', 'Sao Tome and Principe', 'Senegal', 'Seychelles', 'Sierra Leone', 'Somalia', 'South Africa', 'South Sudan', 'Sudan', 'Swaziland', 'Tanzania', 'Togo', 'Tunisia', 'Uganda', 'Zambia', 'Zimbabwe'];
const northAmericaCountries = ['Antigua and Barbuda', 'Bahamas', 'Barbados', 'Belize', 'Canada', 'Costa Rica', 'Cuba', 'Dominica', 'Dominican Republic', 'El Salvador', 'Grenada', 'Guatemala', 'Haiti', 'Honduras', 'Jamaica', 'Mexico', 'Nicaragua', 'Panama', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Trinidad and Tobago', 'United States of America'];
const southAmericaCountries = ['Argentina', 'Bolivia', 'Brazil', 'Chile', 'Colombia', 'Ecuador', 'Guyana', 'Paraguay', 'Peru', 'Suriname', 'Uruguay', 'Venezuela'];
const asiaCountries = ['Armenia', 'Azerbaijan', 'Bangladesh', 'Bhutan', 'Brunei', 'Cambodia', 'China', 'Georgia', 'India', 'Indonesia', 'Japan', 'Kazakhstan', 'Kyrgyzstan', 'Laos', 'Malaysia', 'Maldives', 'Mongolia', 'Myanmar', 'Nepal', 'North Korea', 'Pakistan', 'Philippines', 'Russia', 'Singapore', 'South Korea', 'Sri Lanka', 'Taiwan', 'Tajikistan', 'Thailand', 'Timor Leste', 'Turkmenistan', 'Uzbekistan', 'Vietnam'];
const middleEastCountries = ['Bahrain', 'Cyprus', 'Egypt', 'Iran', 'Iraq', 'Israel', 'Jordan', 'Kuwait', 'Lebanon', 'Oman', 'Palestine', 'Qatar', 'Saudi Arabia', 'Syria', 'Turkey', 'United Arab Emirates', 'Yemen'];
const oceanPacificCountries = ['Australia', 'Federated Islands of Micronesia', 'Fiji', 'French Polynesia', 'Guam', 'Kiribati', 'Marshall Islands', 'Nauru', 'New Zealand', 'Paulau', 'Papua New Guinea', 'Samoa', 'Solomon Islands', 'Tonga', 'Tuvala', 'Vanuata'];

export const getAllCountries = (): string[] => {
    return Array.from(new Set([
        ...europeanCountries,
        ...africaCountries,
        ...northAmericaCountries,
        ...southAmericaCountries,
        ...asiaCountries,
        ...middleEastCountries,
        ...oceanPacificCountries
    ]));
};

export async function getCountriesWithSanctions(): Promise<Record<string, string[]>> {
    try {
        // const sanctionedDoc = await collection('compliance').doc('sanctionedCountries').get();
        const sanctionedDoc = await getDoc(doc(db, 'compliance', 'sanctionedCountries'));
        const sanctionedCountries = sanctionedDoc.exists ? sanctionedDoc.data()?.sanctionedCountries || [] : [];

        return {
            sanctioned: sanctionedCountries,
            europe: europeanCountries,
            africa: africaCountries,
            northAmerica: northAmericaCountries,
            southAmerica: southAmericaCountries,
            asia: asiaCountries,
            middleEast: middleEastCountries,
            oceanPacific: oceanPacificCountries
        };
    } catch (err) {
        console.error('Error getting grouped countries:', err);
        return {
            sanctioned: [],
            europe: [],
            africa: [],
            northAmerica: [],
            southAmerica: [],
            asia: [],
            middleEast: [],
            oceanPacific: []
        };
    }
}

export const getCountryRegion = (country: string): string => {
  if (europeanCountries.includes(country)) return 'Europe';
  if (africaCountries.includes(country)) return 'Africa';
  if (northAmericaCountries.includes(country)) return 'North America';
  if (southAmericaCountries.includes(country)) return 'South America';
  if (asiaCountries.includes(country)) return 'Asia';
  if (middleEastCountries.includes(country)) return 'Middle East';
  if (oceanPacificCountries.includes(country)) return 'Oceanic and Pacific';
  return 'Unknown';
};

/**
 * Returns a curated list of popular countries for quick selection in UIs.
 * This is intended for use as a 'Popular Countries' group in country selectors.
 */
export const getPopularCountries = (): string[] => {
  return [
    'Australia',
    'New Zealand',
    'United Kingdom',
    'United States of America',
    'Canada',
  ];
};

/**
 * @deprecated Use getPopularCountries instead.
 */
export const getPopulatedCountries = getPopularCountries;

export default {
  getAllCountries,
  getCountriesWithSanctions,
  getCountryRegion,
  getPopularCountries,
  getPopulatedCountries
};
  